import logo from './instagram.svg'

export const Footer: React.FC = () => {
  const now = new Date()

  return (
    <footer className="lg:hidden py-10 px-6">
      <div className="max-w-md mx-auto flex flex-row items-start justify-between">
        <nav className="flex flex-col gap-2 text-[15px] text-black">
          <a href="https://flowr.is" className="hover:text-main transition-colors">
            FLOWER公式サイト
          </a>
          <a href="https://flowr.jp" className="hover:text-main transition-colors">
            運営会社
          </a>
          <a href="/policy" className="hover:text-main transition-colors">
            プライバシーポリシー
          </a>
          <a href="/terms" className="hover:text-main transition-colors">
            利用規約
          </a>
          <a href="/commercial" className="hover:text-main transition-colors">
            特定商取引法に基づく表示
          </a>
        </nav>
        <a href="https://www.instagram.com/flowr_is/" target="_blank" rel="noopener noreferrer">
          <img src={logo} alt="FLOWER" className="h-12 w-12" />
        </a>
      </div>
    </footer>
  )
}
